import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type SiteFooterBlockFragment = { id: string, pk: number, name: string, links: Array<{ id: string, pk: number, sortOrder: number, linkText: string, linkAddress: string }> };

export const SiteFooterBlockFragmentDoc = gql`
    fragment SiteFooterBlockFragment on FooterBlockType {
  id
  pk
  name
  links {
    id
    pk
    sortOrder
    linkText
    linkAddress
  }
}
    `;